import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "element-header" }
const _hoisted_4 = { class: "element-box" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-5" }

import {computed, onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import userService from '@/api/User';
import userContractService from '@/api/UserContract';
import BackButton from '@/components/button/BackButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import SelectVue from '@/components/SelectVue.vue';
import {ErrorToast, SuccessToast, WarningToast} from '@/components/VueToast';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import UserMenu from '@/views/App/User/UserMenu.vue';
import ContractDocumentView from '@/views/App/MyContracts/ContractDocumentView.vue';
import ContractList from '@/views/App/MyContracts/ContractList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const route = useRoute();
const userId = Number(route.params.id);
const piniaEnumsState = piniaEnumsStore();

const userData = ref<any>(null);
const contracts = ref<any[]>([]);
const isLoaded = ref(false);
const selectedDocumentId = ref<number | null>(null);
const showCreateModal = ref(false);
const newContractType = ref<string | null>(null);
const isSaving = ref(false);
const contractIdToDelete = ref<number | null>(null);

const contractTypesDropdown = computed(() => piniaEnumsState.enums?.userContractTypes || []);

async function getContracts() {
  try {
    const {data} = await userContractService.getUserContracts(userId);
    contracts.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
  // BSG signature can complete the contract and enable the user
  await getUser();
}

async function getUser() {
  try {
    const {data} = await userService.getUser(userId);
    userData.value = data?.data?.user;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function createContract() {
  if (!newContractType.value) {
    WarningToast('Bitte wählen Sie den Vertragstyp aus.');
    return;
  }
  if (isSaving.value) {
    return;
  }

  isSaving.value = true;
  try {
    const {data} = await userContractService.createContract(userId, newContractType.value);
    contracts.value = data.data;
    showCreateModal.value = false;
    newContractType.value = null;
    SuccessToast('Vertrag wurde erstellt.');
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSaving.value = false;
  }
}

async function deleteContract() {
  if (contractIdToDelete.value === null || isSaving.value) {
    return;
  }

  isSaving.value = true;
  try {
    const {data} = await userContractService.deleteContract(contractIdToDelete.value);
    contracts.value = data.data;
    SuccessToast('Vertrag wurde gelöscht.');
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSaving.value = false;
    contractIdToDelete.value = null;
  }
}

onMounted(async () => {
  // Enums are persisted in local storage, reload them if they are older than contract types
  if (!piniaEnumsState.enums?.userContractTypes) {
    await piniaEnumsState.getEnums();
  }

  await getContracts();
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (selectedDocumentId.value === null)
              ? (_openBlock(), _createBlock(BackButton, {
                  key: 0,
                  label: _ctx.$t('general.button.back'),
                  to: { name: 'userList' },
                  marginBottom: "5"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, " Verträge - " + _toDisplayString(userData.value?.firstName) + " " + _toDisplayString(userData.value?.lastName) + " (" + _toDisplayString(userData.value?.engagementTypeTranslation) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(UserMenu, {
                userId: _unref(userId),
                employeeType: userData.value?.employeeType
              }, null, 8, ["userId", "employeeType"]),
              _createElementVNode("div", _hoisted_5, [
                (selectedDocumentId.value !== null)
                  ? (_openBlock(), _createBlock(ContractDocumentView, {
                      key: selectedDocumentId.value,
                      "document-id": selectedDocumentId.value,
                      "is-bsg-side": true,
                      onBack: _cache[0] || (_cache[0] = ($event: any) => (selectedDocumentId.value = null)),
                      onSigned: getContracts
                    }, null, 8, ["document-id"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, [
                          _cache[7] || (_cache[7] = _createTextVNode(" Status Zugang: ", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", userData.value?.enabled === false ? 'text-bg-warning' : 'text-bg-success'])
                          }, _toDisplayString(userData.value?.enabled === false ? 'Gesperrt bis zur Vertragsunterschrift' : 'Freigeschaltet'), 3)
                        ]),
                        (userData.value?.engagementType === 'extern')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-outline-primary mb-3",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showCreateModal.value = true))
                            }, " Neuer Vertrag "))
                          : _createCommentVNode("", true)
                      ]),
                      (!contracts.value.length)
                        ? (_openBlock(), _createBlock(EmptyState, {
                            key: 0,
                            icon: "fa-file-signature",
                            title: "Keine Verträge gefunden"
                          }))
                        : (_openBlock(), _createBlock(ContractList, {
                            key: 1,
                            contracts: contracts.value,
                            "is-bsg-side": true,
                            onOpen: _cache[2] || (_cache[2] = ($event: any) => (selectedDocumentId.value = $event)),
                            onDelete: _cache[3] || (_cache[3] = ($event: any) => (contractIdToDelete.value = $event))
                          }, null, 8, ["contracts"]))
                    ], 64))
              ])
            ])
          ])),
      _createVNode(Modal, {
        modelValue: showCreateModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showCreateModal).value = $event)),
        title: "Neuer Vertrag",
        sizeModal: "modal-md",
        "button-label": "Vertrag erstellen",
        "hide-cancel": false,
        "on-save": createContract
      }, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createElementVNode("p", null, "Der Vertrag wird mit den aktuellen Daten des Mitarbeiters (Adresse, Honorar) erstellt.", -1)),
          _createVNode(SelectVue, {
            modelValue: newContractType.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newContractType).value = $event)),
            options: contractTypesDropdown.value,
            required: true,
            label: "Vertrag"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalConfirm, {
        "model-value": contractIdToDelete.value !== null,
        header: "Vertrag löschen",
        "confirmation-question": "Vertrag wirklich löschen? Bereits geleistete Unterschriften gehen verloren.",
        "is-processing": isSaving.value,
        "on-confirm": deleteContract,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (contractIdToDelete.value = null))
      }, null, 8, ["model-value", "is-processing"])
    ]),
    _: 1
  }))
}
}

})